import { useContext } from 'react';

import { L10nContext } from 'context/L10nContext';

import { useKeyPress } from 'presentation/hooks';
import { ModalNotification } from 'presentation/ui/components/modal-notification/ModalNotification';
import { ModalNotificationLevel } from 'presentation/ui/components/modal-notification/ModalNotificationLevel';
import { ColumnLayoutSection } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSection';
import { ColumnLayoutSectionMode } from 'presentation/ui/layouts/column-layout/column-layout-section/ColumnLayoutSectionMode';
import { ColumnLayout, ColumnLayoutMode } from 'presentation/ui/layouts/column-layout/ColumnLayout';
import { ButtonPrimary } from 'presentation/ui/partials/button/button-primary/ButtonPrimary';

export interface FolderEditSuccessNotificationProps {
	folder: string;
	onClickConfirm: () => void;
}

export const FolderEditSuccessNotification = (props: FolderEditSuccessNotificationProps): JSX.Element => {
	const { folder, onClickConfirm } = props;

	const l10nContext = useContext(L10nContext);

	useKeyPress('Enter', onClickConfirm);

	const modalMessage = {
		first: l10nContext.translate('view.documents.modal.action.edit.successMessage.first', 'Ordner wurde erfolgreich in'),
		last: l10nContext.translate('view.documents.modal.action.edit.successMessage.last', 'umbenannt')
	};

	return (
		<>
			<ModalNotification
				caption={l10nContext.translate('common.modal.successCaption', 'Abgeschlossen')}
				level={ModalNotificationLevel.LEVEL_SUCCESS}
			/>

			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<>
						{modalMessage.first} <b>{folder}</b> {modalMessage.last}
					</>
				</ColumnLayoutSection>
			</ColumnLayout>

			<ColumnLayout mode={ColumnLayoutMode.ALIGN_CENTER}>
				<ColumnLayoutSection mode={ColumnLayoutSectionMode.MODE_FIXED}>
					<ButtonPrimary
						buttonText={l10nContext.translate('view.documents.modal.action.edit.btnSuccess', 'Weiter zur Ordner Detailanischt')}
						onClick={onClickConfirm}
					/>
				</ColumnLayoutSection>
			</ColumnLayout>
		</>
	);
};
